import { useEffect, useRef } from 'react';

import { isEditableTarget, isPrintableCharacter } from 'utils/keyboard';

import { isTopmostInstance, registerInstance, unregisterInstance } from './utils';

const useFocusSearchOnType = ({ enabled, inputRef, onType }) => {
  const instanceRef = useRef({});

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const instance = instanceRef.current;

    registerInstance(instance);

    const onKeyDown = e => {
      if (e.defaultPrevented || !isTopmostInstance(instance)) {
        return;
      }

      if (isEditableTarget(e.target) || !isPrintableCharacter(e) || e.key === ' ') {
        return;
      }

      const input = inputRef.current;

      if (!input) {
        return;
      }

      e.preventDefault();
      input.focus();
      onType(e.key);
    };

    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      unregisterInstance(instance);
    };
  }, [enabled, inputRef, onType]);
};

export default useFocusSearchOnType;
